import { Outlet } from "react-router-dom";
import { SkipLink } from "@/components/SkipLink";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import { ScrollToTop } from "@/components/ScrollToTop";
import { DevoryBackground } from "@/components/background/DevoryBackground";

/**
 * The Devory environment lives here, once, for every route: a fixed dotted
 * field with a pointer-tracked glow (see DevoryBackground.tsx), quiet and
 * dark by default. An earlier pass instead put a fixed high-contrast line
 * grid and column rules behind every page, which made the site feel like
 * the inside of a node editor. This is the restrained replacement: light
 * indicates activity, the field never competes with text. See the
 * 2026-07-18 brand redesign pass and docs/DESIGN_ASSESSMENT_2026-07.md §3, §8.
 */
export function RootLayout() {
  return (
    <>
      <DevoryBackground />
      <ScrollToTop />
      <SkipLink />
      <SiteHeader />
      <main id="main-content">
        <Outlet />
      </main>
      <SiteFooter />
    </>
  );
}
